import { CommonModule } from '@angular/common'
import { Component, input } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface VistaVendorRow {
    displayName: string
    kind: string
    lineCount: number
    spend: number
    status: string
    vistaVendor: number | null
    vistaName: string
    reason: string
    runnerUp: string
}

interface VistaVendorSummary {
    vendorCount: number
    matchedCount: number
    ambiguousCount: number
    unmatchedCount: number
    vendorMatchedPercent: number
    spendMatchedPercent: number
    totalSpend: number
    matchedSpend: number
    vendors: VistaVendorRow[]
}

@Component({
    selector: 'app-purchased-materials-vista-vendors',
    templateUrl: './purchased-materials-vista-vendors.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsVistaVendorsComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)

    vendorGrid: Grid<VistaVendorRow>
    summary: VistaVendorSummary | null = null

    constructor() {
        super()
        this.vendorGrid = new Grid<VistaVendorRow>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, true),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    private clear() {
        this.summary = null
        this.vendorGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            'vistaVendors',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetVistaVendors', filters))
                .subscribe({
                    next: result => {
                        this.summary = result[0]
                        this.vendorGrid.items = result[0].vendors ?? []
                    },
                }),
        )
    }
}
